import { ClearIcon } from '@mui/x-date-pickers'
import styles from './FilterSelectorPopper.module.css'
import { Box, Button, Checkbox, Fade, FormControlLabel, IconButton, Paper, Popper } from '@mui/material'
import { useEffect, useLayoutEffect, useState } from 'react'
import { ClickAwayListener } from '@mui/material'
import { useBreakpointUp } from 'shared/hooks/useBreakpointQueries'

interface FilterSelectorPopperProps {
    anchor?: any
    text: string
    open: boolean
    items: any[]
    selectedItems: any[]
    onClose?: (event: any) => void
    onSelectItemChange?: (event: any) => void
    onApplyFilter?: (event: any) => void
    onClearFilter?: (event: any) => void
}

export const FilterSelectorPopper = (props: FilterSelectorPopperProps): JSX.Element => {
    const {
        anchor,
        text,
        open,
        onClose,
        items,
        selectedItems,
        onApplyFilter,
        onSelectItemChange,
        onClearFilter
    } = props

    const handleCloseClick = (event: any) => {
        onClose?.(event)  
    }

    const handleClearClick = (event: any) => {
        onClearFilter?.(event)
    }

    const handleFormChange = (event: any) => {
        onSelectItemChange?.({
            name: event.target.name,
            value: event.target.value,
            checked: event.target.checked
        })
    }

    const handleApply = (event: any) => {
        onApplyFilter?.(event)
        onClose?.(event)
    }

    const getList = () => {
        if (items === undefined || items.length === 0) {
            return (
                <></>
            )
        }

        const content = items.map((item) => {
            return (
                <FormControlLabel
                    key={item.label}
                    className={styles.FilterSelectorDrawer__ListFormControlLabel}
                    control={
                        <Checkbox
                            checked={selectedItems?.includes(item.label) || false}
                            className={styles.FilterSelectorPopper__ListCheckbox}
                            name={item.label}
                            sx={{ '& .MuiSvgIcon-root': { fontSize: 36, fill: '#222222' } }}
                        />
                    }
                    label={<span className={styles.FilterSelectorPopper__ListCheckboxLabel}>{item.label}</span>} />
            )
        })

        return content
    }

    const list = getList()

    const handleClickAway = (event: any) => {
        onClose?.(event)  
    }


    const popperOptions: any = {
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 20],
                },
            },
            {
                name: 'flip',
                options: {
                    fallbackPlacements: ['auto']
                },
            },
            {
                name: 'computeStyles',
                enabled: true,
                fn({ state }: any) {
                    state.styles.popper = {
                        ...state.styles.popper,
                        position: 'fixed',
                        left: `${(window.innerWidth - state.rects.popper.width) / 2}px`,
                        top: '50%',
                        transform: 'translateY(-50%)',
                    }

                    return state
                },
            }
        ]
    }

    const anchorVirtualElement: any = {
        getBoundingClientRect: () => {
            return {
                width: window.innerWidth,
                height: 0,
                top: 90,
                right: 0,
                bottom: 0,
                left: 0,
            }
        },
    }

    const isXlWidthScreenOrMore = useBreakpointUp('xl')
    const papperStyle = isXlWidthScreenOrMore ? {} : {height: '100vh'}

    return (
        <Popper
            className={styles.FilterSelectorPopper}
            open={open}
            anchorEl={anchor?.current}
            placement={`bottom`}
            popperOptions={popperOptions}
        >
            <ClickAwayListener onClickAway={handleClickAway}>

                <Paper className={styles.FilterSelectorPopper__ContentContainer} sx={papperStyle}>
                <div
                    className={styles.FilterSelectorPopper__MainToolBar}
                >
                    <IconButton
                        className={styles.FilterSelectorPopper__MainToolBarClose}
                        onClick={handleCloseClick}
                    >
                        <ClearIcon
                            className={styles.FilterSelectorPopper__MainToolBarCloseIcon}
                        />
                    </IconButton>
                    <div
                        className={styles.FilterSelectorPopper__MainToolBarTitle}
                    >
                        {text}
                    </div>
                    <Button
                        className={styles.FilterSelectorPopper__MainToolBarClear}
                        variant="text"
                        onClick={handleClearClick}
                    >
                        Clear
                    </Button>
                </div>
                <hr className={styles.FilterSelectorPopper__MainToolBarDivider} />
                <form onChange={handleFormChange}>
                    <div className={styles.FilterSelectorPopper__List}>
                        {list}
                    </div>
                    <div className={styles.FilterSelectorPopper__BottomToolbar}>
                        <Button
                            className={styles.FilterSelectorPopper__Button__Apply}
                            color="success"
                            variant="contained"
                            onClick={handleApply}
                        >
                            Apply
                        </Button >
                    </div>
                </form>
                </Paper>
            </ClickAwayListener>
        </Popper>
    )
}